import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import { Form, Errors, LocalForm, Control, actions, Field } from 'react-redux-form';
 
import { Provider } from 'react-redux';
import * as CreDtos from "../../../CRE.dtos";
import * as Config from '../../../configuration/consts';

import TextFormGroup from "../../Controls/TextFormGroup";
import ValidationMessage from "../../Controls/ValidationMessage";
import { required, maxLength, numberRange } from "../../Validators/";
import {
  updateOn,
  validateOn,
  mapProps,
  showErrors
} from "../../Controls/ReactReduxFormSettings";


@withRouter
export class AddForum extends React.Component<any, any> {
    formDispatch;
    constructor(props) {
        super(props);

        this.state = { confirmDelete: false, showDetail: (props.editingForum != undefined), theme: "", colour: "" };
        this.onLocalSubmit = this.onLocalSubmit.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.onCancelClicked = this.onCancelClicked.bind(this);
        this.onToggleClicked = this.onToggleClicked.bind(this);
        this.onColourChanged = this.onColourChanged.bind(this);
        this.onThemeChanged = this.onThemeChanged.bind(this);
        
    }

    onToggleClicked(){
        this.setState({ showDetail: !this.state.showDetail });
    }

    onThemeChanged(event){
        
        this.setState({ theme: event.target.value });
    }

    onColourChanged(event){
        
        this.setState({ colour: event.target.value });
    }
    
    onDeleteClicked() {
        this.setState({ confirmDelete: !this.state.confirmDelete });
    }

    onCancelClicked(event) {
        this.props.clearForum();
        this.setState({ showDetail: false });
        this.formDispatch(actions.reset('forum'));
        event.preventDefault();
    }

    onLocalSubmit(values, event) {
        this.onSubmit(values);
    }

    async onSubmit(form) {
        let forum = new CreDtos.Forum();
        forum = {...form};
        forum.obsolete = this.state.confirmDelete;
        this.props.saveForum(forum);
        this.setState({ showDetail: false });
        this.formDispatch(actions.reset('forum'));
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.editingForum && !this.props.editingForum.id && this.state.confirmDelete){
                this.onDeleteClicked();
        }
        if(prevProps.editingForum !== this.props.editingForum && this.props.editingForum){
            this.setState({ showDetail: true, 
                            theme: this.props.editingForum.theme,  
                            colour: this.props.editingForum.themeColour });
        } 
        if( this.formDispatch )
        {
            if(this.props.editingForum && this.state.showDetail)
            {
                this.formDispatch(actions.change('forum', this.props.editingForum));
            }
        }
    }
    
    render() {
        const { userRole, currentUser, forum, editingForum, ...props } = this.props;
        let isAdmin = true; //userRole == Config.ADMIN;
        
        let deleteButton = isAdmin && editingForum && editingForum.id ? <span> <a className="btn btn-danger mr-2" onClick={this.onDeleteClicked}>DELETE</a>  </span> : undefined;
        let actionButtons = this.state.confirmDelete ? <div className="alert alert-warning alert-dismissible fade show">
                <span className="fa fa-warning fa-2x mr-2"></span>
                Are you sure you want to delete this user?
                <a className="btn btn-default mx-2 lightgrey-bg pull-right" onClick={this.onDeleteClicked}>NO</a><button type="submit" className="btn btn-default pull-right">YES</button>
            </div> : <div className="pull-right">{deleteButton}<button type="reset" className="btn btn-primary mr-2" onClick={this.onCancelClicked}>CANCEL</button><button type="submit" className="btn btn-primary">SAVE</button></div>;

        let content = this.state.showDetail ? <LocalForm model="forum" 
        onSubmit={this.onLocalSubmit.bind(this)} 
        getDispatch={(dispatch) => this.formDispatch = dispatch}
        validateOn="submit">

<div className="card lightgrey-bg">
<div className="card-block">
    <div className="row">

        <div className="col-12">
            <div className="row">
                <div className="col-12 mb-1 ">
                    <strong>ADD / EDIT BOARD</strong>
                </div>
                <div className="col-12 mb-1">
                    <Control.text
                        model=".title"
                        id="forum.title"
                        component={TextFormGroup}
                        placeholder="Title..."
                        validators={{
                            required: required,
                            maxLength: maxLength.bind(null, 255)
                        }}
                        updateOn={updateOn}
                        validateOn={validateOn}
                        mapProps={mapProps}
                        maxLength={255}
                        controlProps={{
                            validate: true
                        }}
                        >
                        <Errors
                            model=".title"
                            messages={{
                            required: "Title is required",
                            maxLength: "Title is too long"
                            }}
                            show={showErrors}
                            component={ValidationMessage}
                        />
                        </Control.text>
                </div>
                <div className="col-12 mb-1 ">
                    <Control.text
                        model=".defaultMessage"
                        id="user.defaultMessage"
                        component={TextFormGroup}
                        placeholder="Default post message..."
                        validators={{
                            maxLength: maxLength.bind(null, 255)
                        }}
                        updateOn={updateOn}
                        validateOn={validateOn}
                        mapProps={mapProps}
                        maxLength={255}
                        controlProps={{
                            validate: true
                        }}
                        >
                        <Errors
                            model=".defaultMessage"
                            messages={{
                            maxLength: "Default message is too long"
                            }}
                            show={showErrors}
                            component={ValidationMessage}
                        />
                        </Control.text>
                </div>
                <div className="col-12 mb-1 ">
                    <Control.text
                        model=".defaultResourceMessage"
                        id="forum.defaultResourceMessage"
                        component={TextFormGroup}
                        placeholder="Default resource message..."
                        validators={{
                            maxLength: maxLength.bind(null, 255)
                        }}
                        updateOn={updateOn}
                        validateOn={validateOn}
                        mapProps={mapProps}
                        maxLength={255}
                        controlProps={{
                            validate: true
                        }}
                        >
                        <Errors
                            model=".defaultResourceMessage"
                            messages={{
                            required: "Default resource message is required",
                            maxLength: "Default resource message is too long"
                            }}
                            show={showErrors}
                            component={ValidationMessage}
                        />
                        </Control.text>
                </div>
                <div className="col-12 mb-1 ">
                    <Control.text
                        model=".rank"
                        id="forum.rank"
                        component={TextFormGroup}
                        placeholder="Ranking (number)"
                        validators={{
                        }}
                        updateOn={updateOn}
                        validateOn={validateOn}
                        mapProps={mapProps}
                        maxLength={255}
                        controlProps={{
                            validate: true
                        }}
                        >
                        <Errors
                            model=".rank"
                            messages={{
                                numberRange: "Minimum rank is 1"
                            }}
                            show={showErrors}
                            component={ValidationMessage}
                        />
                        </Control.text>
                </div>
                <div className="col-6 mb-1 ">
                    <label>Background Colour</label>
                    <Control.select model=".themeColour" className="form-control" >
                        <option value=""></option>
                        <option value="yellow">YELLOW</option>
                        <option value="red">RED</option>
                        <option value="green">GREEN</option>
                    </Control.select>
                </div>
                <div className="col-6 mb-1 ">
                    <label>Theme</label>
                    <Control.select model=".theme" className="form-control" >
                        <option value=""></option>
                        <option value="research-banner-1">Large horse shoe</option>
                        <option value="research-banner-2">Clustered dots</option>
                        <option value="research-banner-3">Matchsticks</option>
                        <option value="research-banner-4">Horizontal dotted lines</option>
                        <option value="research-banner-5">Small horse shoes</option>
                    </Control.select>
                </div>
                <div className="col-12">
                    {actionButtons}
                </div>
            </div>
        </div>
    </div>
</div>
</div>
</LocalForm> : <div className="col-12 pr-0 pull-right"><a className="btn btn-default mx-2 lightgrey-bg pull-right" onClick={this.onToggleClicked}>ADD BOARD</a></div>;
        return ( content );
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Forum/AddForum.tsx